import { Component, AfterViewInit, OnDestroy,NgZone } from '@angular/core'

import { ClientContactService, LocalizeService } from '../../insa-services'
import { appStateProvider } from '../../insa-providers'
import { ClientContactModel, ClientContactTypesModel, ClientContactsColumnDefintion } from '../../insa-models'
import { SharedMethodsModule } from '../../insa-custom-scripts'

@Component({
  template: '<div class="canvas"><div id="ClientContacts" class="contacts-loading"></div></div>'
})
export class ClientContactComponent implements AfterViewInit, OnDestroy {

private clientContactsSubscription: any;
private clientContactTypesSupscription: any;
private contactTypes: ClientContactTypesModel;
private contacts: ClientContactModel;

 constructor(private _clientContactService: ClientContactService, private _localize: LocalizeService, private _appStateProvider: appStateProvider,private zone: NgZone) {
       window['clientComponentRef'] = {
        zone: this.zone, 
        component: this
      };
       this.clientContactsSubscription = this._clientContactService.ClientContactsEvent.subscribe(contact => {this.clientContactsTable(contact,this.createClientContactsColumnDefinition())});
     }

     //TransactionGridColumnDefs.push(new KendoColumnDefinition("AccruedInterest", this._localize.getLocalizedResource('Res862'),'#: (AccruedInterest!==null) ? kendo.toString(AccruedInterest, "n2"): "" #', '',

  private createClientContactsColumnDefinition() {
    let clientContacts = new Array<ClientContactsColumnDefintion>();
    clientContacts.push(new ClientContactsColumnDefintion("ContactDate", this._localize.getLocalizedResource('Res928'), '#: (ContactDate!==null)? kendo.toString(ContactDate, "dd.MM.yyyy"): ""#'));
    let contactType:ClientContactsColumnDefintion = new ClientContactsColumnDefintion("ContactType", this._localize.getLocalizedResource('Res136'));
    if(this._clientContactService.clientContactTypes!==undefined){
      contactType.values = this._clientContactService.clientContactTypes.map(function (item) {
        let newData: Object = { text: item.Description, value: item.ContactType };
        return newData;
      });
      clientContacts.push(contactType);
    }
    clientContacts.push(new ClientContactsColumnDefintion("Reference", this._localize.getLocalizedResource('Res3142'), '#: (Reference!==null)? Reference : ""#'));
    clientContacts.push(new ClientContactsColumnDefintion("FileName", this._localize.getLocalizedResource('Res3275'), '#: (FileName!==null)? FileName : ""#'));
    clientContacts.push(new ClientContactsColumnDefintion("ContactNotes", this._localize.getLocalizedResource('Res2481'), '#: (ContactNotes!==null)? ContactNotes: ""#'));
    clientContacts.push(new ClientContactsColumnDefintion("Subject", this._localize.getLocalizedResource('Res437'),'#: (Subject!==null)? Subject : ""#'));
    clientContacts.push(new ClientContactsColumnDefintion("CreateDate", this._localize.getLocalizedResource('Res4301'), '#: (CreateDate!==null)? kendo.toString(CreateDate, "dd.MM.yyyy"): ""#', true));
    clientContacts.push(new ClientContactsColumnDefintion("ContactEndDate", this._localize.getLocalizedResource('Res1784'), '#: (ContactEndDate!==null)? kendo.toString(ContactEndDate, "dd.MM.yyyy"): ""#', true));
    clientContacts.push(new ClientContactsColumnDefintion("Recommendation", this._localize.getLocalizedResource('Res423'), '#: (Recommendation!==null)? Recommendation : ""#', true));
    clientContacts.push(new ClientContactsColumnDefintion("Signature", this._localize.getLocalizedResource('Res425'), '#: (Signature!==null)? Signature : ""#',true, 130, this.customBoolEditor.bind(this)));
    clientContacts.push(new ClientContactsColumnDefintion("Outcome", this._localize.getLocalizedResource('Res424'), '#: (Outcome!==null)? Outcome : ""#',true));
    clientContacts.push(new ClientContactsColumnDefintion("Location", this._localize.getLocalizedResource('Res438'), '#: (Location!==null)? Location : ""#',true));
    clientContacts.push(new ClientContactsColumnDefintion("Initiator", this._localize.getLocalizedResource('Res215'), '#: (Initiator!==null)? Initiator : ""#',true));
    
    this.customizeGridColumns(clientContacts);
    return clientContacts;
  }

  private customizeGridColumns(kendoColumn){
     let columnStyleLeftAlign: any = {style:"font-size:1rem;text-transform:none;"};
     let headerStyleLeftAlign: any = {style: "text-transform:none;"};
     let columnStyleRightAlign: any = {style:"text-align:right;font-size:1.2rem;text-transform:none;"};
     let headerStyleRightAlign: any = {style: "text-align:right;text-transform:none;"};

     for(let i = 0; i < kendoColumn.length; i++){
        kendoColumn[i].attributes = columnStyleLeftAlign;
        kendoColumn[i].headerAttributes = headerStyleLeftAlign;         
         
         switch(kendoColumn[i].field){
               case "ContactNotes":
               case "FileName": 
               case "Signature":
               case "ContactEndDate":   
               case "Outcome":                 
               case "Recommendation":
                 kendoColumn[i].groupable = false;
                 break;  
         }
     } 
}

 private customBoolEditor(container, options) {
    $('<input type="checkbox" value="#: Signature #">').appendTo(container);
 }

  private clientContactsTable(griddata, columnDefs) {
    // console.log(griddata)
    let griddataNextID: number;
    if (griddata !== undefined && griddata !== null) {
      griddataNextID = griddata.length + 1;
    }
    function getIndexById(contactId) {
      let idx,
        l = griddata.length;
      for (var j = 0; j < l; j++) {
        if (griddata[j].ContactID == contactId) {
          return j;
        }
      }
      return null;
    }

    columnDefs.push({ command: [{ name: "edit", text: "DETAILS" }, { name: "destroy" }], title: "&nbsp;", width: "250px" });
    let dataSourceOptions: kendo.data.DataSourceOptions = {};
    let compRef = window['clientComponentRef'].component;
    let compRefFunctionRun = window['clientComponentRef'].zone;

    dataSourceOptions.transport = {
      read: function (e) {
        if (griddata !== undefined)
          e.success(griddata);
      },
      update: function (e) {
        griddata[getIndexById(e.data.ContactID)] = e.data;
        compRefFunctionRun.run(() => {
          compRef._clientContactService.updateClientContacts(griddata[getIndexById(e.data.ContactID)])
            .subscribe(updatedData => compRef._clientContactService.getClientContacts())
        });
        e.success();
      },
      create: function (e) {
        //let compRef = window['clientComponentRef'].component;
        e.data.ContactID = griddataNextID++;
        e.data.PartnerIndex = compRef._appStateProvider.selectedPartner.value;
        let newContact = e.data;
        compRefFunctionRun.run(() => {
          compRef._clientContactService.addClientContacts(newContact)
            .subscribe(newData => compRef._clientContactService.getClientContacts())
        });
        e.success(e.data);
      },
      destroy: function (e) {
       // let compRef = window['clientComponentRef'].component;
       compRefFunctionRun.run(() => {
        compRef._clientContactService.deleteClientContacts(e.data.ContactID)
          .subscribe(deletedData => compRef._clientContactService.getClientContacts())
      });
        //compRef._clientContactService.deleteClientContacts(e.data.ContactID).subscribe(data => compRef._clientContactService.getClientContacts());
        e.success();
      }
    }
    dataSourceOptions.schema = {
      model: {
        id: "ContactID",
        fields: {
          ContactDate: { type: "date" },
          ContactType: { type: "number", defaultValue: 1 },
          ContactNotes: { type: "string" },
          FileName: { type: "string" },
          Signature: { type: "string" },
          Outcome: { type: "string" },
          Reference: { type: "string" },
          Subject: { type: "string" },
          Recommendation: { type: "string" },
          CreateDate: { type: "date" },
          ContactEndDate: { type: "date" },
          Location: { type: "string" },
          Initiator: { type: "string" }
        }
      }
    };
    let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
    let clientGrid: kendo.ui.Grid = $("#ClientContacts").data("kendoGrid");

    if (clientGrid === undefined) {
      let clientContactsOptions: kendo.ui.GridOptions = {};
      clientContactsOptions.dataSource = dataSource;
      clientContactsOptions.selectable = true;
      clientContactsOptions.reorderable = true;
      clientContactsOptions.resizable = true;
      clientContactsOptions.pageable = false;
      clientContactsOptions.scrollable = true;
      clientContactsOptions.noRecords = {
        template: SharedMethodsModule.noDataTemplate()
      };
      clientContactsOptions.toolbar = ["create"];
      clientContactsOptions.columns = columnDefs;
      clientContactsOptions.editable = { mode: "popup" };
      $("#ClientContacts").kendoGrid(clientContactsOptions);
    } else {
      clientGrid.setDataSource(dataSource);
    }
   
  }

  ngAfterViewInit() {
     kendo.ui.progress($(".contacts-loading"), this._appStateProvider.fetchingClientContacts); 
     this.clientContactsTable(this._clientContactService.clientContacts,this.createClientContactsColumnDefinition());
  }

  ngOnDestroy() {
    this.clientContactsSubscription.unsubscribe();
    window['clientComponentRef'] = null;
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/client-contact.component.ts